import { mglBlue } from '@/styles/designSystemColors';

/* eslint-disable react/jsx-props-no-spreading */
interface InternalCreditsProps {
  autoria: string;
  urlAutoria: string;
  editoria?: string;
  urlEditoria?: string;
  datas: {
    Publicacao: string;
    PublicacaoFormatada: string;
    Atualizacao?: string;
    AtualizacaoFormatada?: string;
  };
  type?: string;
}

export default function InternalCredits({ autoria, urlAutoria, editoria, urlEditoria, datas, type = '' }: InternalCreditsProps) {
  const rel = {};

  if (type === 'artigo' || type === 'analise') Object.assign(rel, { rel: 'author' });

  return (
    <p className="mt-2 text-base font-light text-mglGray700 [&>a]:cursor-pointer [&>a]:text-mglGray700 [&>a]:no-underline">
      <>
        Por&nbsp;
        {urlAutoria ? (
          <a
            className="text-mglBlue600 text-opacity-100 shadow-[inset_0_-8px_0_0_rgb(39_169_225_/_10%)] transition-all duration-500 hover:shadow-[inset_0_-1.15em_0_rgb(39_169_225_/_10%)]"
            style={{ color: mglBlue.mglBlue600 }}
            href={urlAutoria}
            {...rel}>
            {autoria}
          </a>
        ) : (
          <span> {autoria} </span>
        )}
        {typeof editoria !== 'undefined' && editoria !== null && (
          <>
            &nbsp;• Editado por&nbsp;
            {urlEditoria ? (
              <a
                className="text-mglBlue600 text-opacity-100 shadow-[inset_0_-8px_0_0_rgb(39_169_225_/_10%)] transition-all duration-500 hover:shadow-[inset_0_-1.15em_0_rgb(39_169_225_/_10%)]"
                style={{ color: mglBlue.mglBlue600 }}
                href={urlEditoria}>
                {editoria}
              </a>
            ) : (
              <span> {editoria} </span>
            )}
          </>
        )}
      </>
      {datas.PublicacaoFormatada && (
        <>
          &nbsp;|&nbsp;
          <time dateTime={datas.Publicacao}>{datas.PublicacaoFormatada}</time>
        </>
      )}
      {datas.AtualizacaoFormatada && (
        <>
          &nbsp;•&nbsp;
          <time dateTime={datas.Atualizacao}>Atualizado {datas.AtualizacaoFormatada}</time>
        </>
      )}
    </p>
  );
}
